<div class="modal-header">
  <h4 class="modal-title fw-normal">{{ title() }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
  <div class="alert d-flex px-2 py-3 align-items-center gap-2" [class]="alertClasses()">
    <i [class]="icon()"></i>
    <span>{{ message() }}</span>
  </div>
</div>
